import Vue from 'vue'
import App from './App.vue'
import PortalVue from 'portal-vue'
import VueCookies from 'vue-cookies-ts'
import store from './store'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

Vue.config.productionTip = false
Vue.use(VueCookies)
Vue.use(PortalVue)

new Vue({
	store,
  render: h => h(App)
}).$mount('#agent-widget')
